const injectScrollLockStyles = () => {
  if (!document.querySelector("style[hzn-scroll-lock]")) {
    const style = document.createElement("style");
    style.setAttribute("hzn-scroll-lock", "");
    const scrollbarWidth = Math.abs(window.innerWidth - document.documentElement.clientWidth);
    const existingBodyPadding = parseInt(getComputedStyle(document.body).paddingInlineEnd);
    style.innerHTML = `body[data-scroll-lock] { padding-right: ${scrollbarWidth + existingBodyPadding}px !important; overflow: hidden !important;}`;
    document.head.appendChild(style);
  }
};
export {
  injectScrollLockStyles
};
//# sourceMappingURL=scroll-lock.js.map
